import { MedelyDateTime } from '@medely/date-time-tools';

export const isShiftWindowOpen = ({
  shiftWindow,
  startTime,
}: {
  shiftWindow?: number | null;
  startTime?: string | null;
}) => {
  if (!shiftWindow || !startTime) {
    return false;
  }

  const startDateTime = new MedelyDateTime(startTime, { tz: 'system' });
  const now = new Date();
  const nowPlusWindowMs = now.getTime() + shiftWindow * 60 * 60 * 1000;
  const nowPlusWindow = new MedelyDateTime(new Date(nowPlusWindowMs).toISOString(), {
    tz: 'system',
  });

  return nowPlusWindow.isBefore(startDateTime);
};
